import React from 'react'
import { setPropTypes } from '../icons/BaseIcon'

function AARPColorLogo({ width = 67, height = 15 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 67 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3266_9919)">
        <path
          d="M61.2815 5.51718C61.2815 3.95507 60.4508 2.82625 58.833 2.82625H57.7832V8.16394H58.833C60.3632 8.16394 61.2815 7.16554 61.2815 5.51648V5.51718ZM45.9332 5.51718C45.9332 4.08478 45.19 2.82625 43.2218 2.82625H42.4348V8.16394H43.2218C45.0148 8.16394 45.9332 7.16554 45.9332 5.51648V5.51718ZM29.6671 8.68559L28.0493 4.43254L26.4316 8.68559C26.5192 8.68559 27.3937 8.55517 28.0493 8.55517C28.7925 8.59864 29.5795 8.68559 29.6671 8.68559ZM16.6366 8.77252L15.0188 4.38977L13.4449 8.59935C13.707 8.59935 14.0136 8.59935 14.3194 8.59935C15.5875 8.59935 16.5059 8.77323 16.6366 8.77323V8.77252ZM66.6598 5.51718C66.6598 8.59864 64.2112 10.5513 60.188 10.5513H57.7832V14.8043H46.8516L42.4355 9.03264V14.8043H31.8536L30.6731 11.6366C30.5855 11.6366 29.405 11.42 28.0493 11.42C26.6499 11.42 25.4256 11.6366 25.3818 11.6366L24.2013 14.8043H18.8231L17.9485 12.3742C19.2604 12.7213 20.2657 13.2422 20.7905 13.5458L21.0088 12.9814C20.1781 12.5039 17.904 11.3758 14.6684 11.3758C12.1323 11.3758 10.5145 11.9837 7.89073 11.9837C3.64919 11.9837 0.719538 9.94411 0.545044 9.8137L1.68173 7.08C1.98762 7.25388 4.78658 9.07611 8.06593 9.07611C8.63463 9.07611 9.07192 9.03264 9.55231 8.98917L13.0945 0.440308H18.9538L22.4521 9.42317L26.1688 0.440308H32.0281L37.188 13.7197V0.483778H44.184C48.9504 0.483778 51.3114 2.65377 51.3114 5.51788C51.3114 8.382 49.0373 9.51011 48.3817 9.77093L52.4919 14.1972V0.483778H60.1442C64.4295 0.483778 66.6591 2.6103 66.6591 5.51788L66.6598 5.51718ZM12.0892 12.1141C12.0892 12.1141 12.133 12.1141 12.0892 12.1141L11.127 14.805H7.14754L8.10973 12.4619H8.15353C8.37182 12.5053 10.2086 12.4619 12.0892 12.1148V12.1141Z"
          fill="#F53030"
        />
      </g>
      <defs>
        <clipPath id="clip0_3266_9919">
          <rect
            width="66.171"
            height="14.49"
            fill="white"
            transform="translate(0.253784 0.081665)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
setPropTypes(AARPColorLogo)
export default AARPColorLogo
